import React from 'react';
import { motion } from 'framer-motion';
import { Form, Input, Button, message } from 'antd';
import { MailOutlined, PhoneOutlined, EnvironmentOutlined } from '@ant-design/icons';






// Rue Marseille, Résidence Lamadrague, 1er étage, n2, Tanger 90000
// +212 661073383
// +212 662861016
// info@ersmaroc.com


const Contact = () => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    message.success('Merci pour votre message. Nous vous répondrons bientôt !');
    form.resetFields();
  };

  return (
    <div className="min-h-screen bg-blue-50 py-12 px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-3xl mx-auto bg-white shadow-xl rounded-lg overflow-hidden"
      >
        <div className="px-6 py-8">
          <motion.h2
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
            className="text-3xl font-bold text-center text-blue-800 mb-6"
          >
            Contactez ERS
          </motion.h2>
          <p className="text-center text-gray-600 mb-8">
            Contactez Solutions de Ressources Environnementales pour tous vos besoins en irrigation et gestion agricole.
          </p>

          <div className="flex flex-col space-y-8 justify-center items-center">
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.6, duration: 0.5 }}
              className="space-y-4"
            >
              <div className="flex items-center space-x-4">
                <MailOutlined className="text-2xl text-blue-600" />
                <span> info@ersmaroc.com </span>
              </div>
              <div className="flex items-center space-x-4">
                <PhoneOutlined className="text-2xl text-blue-600" />
                <span> +212 661073383 </span>
              </div>
              <div className="flex items-center space-x-4">
                <PhoneOutlined className="text-2xl text-blue-600" />
                <span> +212 662861016 </span>
              </div>
              <div className="flex items-center space-x-4">
                <EnvironmentOutlined className="text-2xl text-blue-600" />
                <span> Rue Marseille, Résidence Lamadrague, 1er étage, n2, Tanger 90000 </span>
              </div>
            </motion.div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default Contact;